/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

import { Link } from 'react-router-dom'
// Utilities
import Header from '../../components/header/index'
import Hero from '../../components/heros/index'
import Container from '../../components/container'
import Footer from '../../components/footer'
import Title from '../../components/title'

const Index = () => {
    Title('Game Hosting - StellaNode')
    return (
        <main>
            <div className="bg-primary-light mb-10">
                <Header />
                <Hero type='primary' title='Game Servers' description='View all of the game servers we offer below' />
            </div>
            <section className='games py-28'>
                <Container>
                    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-16'>
                        <div className='minecraft bg-primary-light text-center rounded-md'>
                            <Link to='/games/minecraft-budget-na' className='block w-full p-6'>
                                <h1 className='text-xl text-gray-100 font-medium'>Minecraft Budget NA</h1>
                            </Link>
                        </div>
                        <div className='minecraft bg-primary-light text-center rounded-md'>
                            <Link to='/games/minecraft-budget-eu' className='block w-full p-6'>
                                <h1 className='text-xl text-gray-100 font-medium'>Minecraft Budget EU</h1>
                            </Link>
                        </div>
                        <div className='minecraft bg-primary-light text-center rounded-md'>
                            <Link to='/games/minecraft' className='block w-full p-6'>
                                <h1 className='text-xl text-gray-100 font-medium'>Minecraft Premium</h1>
                            </Link>
                        </div>
                    </div>
                </Container>
            </section>
            <Footer />
        </main>
    )
}

export default Index